import { mallTradeApi } from '../request'
import { apiPath } from '../api'

export const quarantine = {
  simpleListforqc: data => mallTradeApi.post(apiPath.simpleListforqc, data),
  getqcbyorderids: data => mallTradeApi.post(apiPath.getqcbyorderids, data)
}
